<script>
    
</script>

<style>
    .header{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px 20px;
        color: #fff;
        font-weight: bold;
        font-size: 1.5em;
        background: rgba(0, 0, 0, 0.1);
    }

</style>



<div class="header">
    <span>Onome's Todo list</span>

</div>